class ImageService extends BaseService
	@register()
	@inject 'ConfigurationService'

	resize: (url, width = 250, height = 250, forceExtension = false) ->
		if !_.isString(url) ||
			(@ConfigurationService.isEnabled('Backoffice.Setting.Cdn.Url')) ||
			!(url.startsWith('https://') || url.startsWith('http://'))
				return url

		matches = url.match(/(?<base>.*?)\/(?<name>\w+)\.(?<extension>\w+)$/);

		if !matches
			return url

		if forceExtension == true
			extension = 'jpg'
		else if _.isString(forceExtension)
			extension = forceExtension
		else
			extension = matches.groups.extension

		return "#{matches.groups.base}/#{matches.groups.name}/#{width}x#{height}.#{extension}"
